export const EMPLOYMENT = "EMPLOYMENT";

export default [
	{ value: EMPLOYMENT, key: "employments.employmentTypes.employment" }
];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/enums/employmentTypes.js